import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../config.js';
import { parseApiJson } from '../lib/api-error';

type LinearTeam = { id: string; name: string; key: string };

export function useLinearTeams(enabled = true) {
  return useQuery({
    queryKey: ['linear-teams'],
    queryFn: async (): Promise<{ ok: boolean; data?: LinearTeam[] }> => {
      const res = await fetch(`${API_URL}/integrations/linear/teams`, {
        credentials: 'include',
      });
      return parseApiJson<{ ok: boolean; data?: LinearTeam[] }>(
        res,
        'Failed to fetch Linear teams'
      );
    },
    enabled,
  });
}
